<div class="block__right-side-panel">
    <div class="block-full-width no-padding no-border-radius">
        <div class="edit-profile-account">
            <div class="edit-profile-account-items-area">
                <div class="items-area-top">
                    <h2 class="items-area-top__title">
                        {{ 'YOUR_DETAILS' | translate }}
                    </h2>
                    <div class="items-area-top__item hide-mobile" *ngIf="(actions$ | async)?.length > 0">
                        <ridango-account-actions-selector
                            #actionSelector
                            [isOpened]="actionsDropdownOpened"
                            [actions]="actions$ | async"
                            [locale]="locale"
                            (onDropdownStatusChange)="dropdownStateChange($event)"
                            (onActionClicked)="actionClicked($event)">
                        </ridango-account-actions-selector>
                    </div>
                </div>

                <ng-container *ngIf="(customerFields$ | async).indexOf('name') >= 0">
                    <p class="edit-profile-account-items-area__item-title">{{ 'PH_CUSTOMER_NAME' | translate }}</p>
                    <p class="edit-profile-account-items-area__item-info">{{ (profile$ | async)?.name }}</p>
                </ng-container>

                <ng-container *ngIf="(customerFields$ | async).indexOf('email') >= 0">
                    <p class="edit-profile-account-items-area__item-title">{{ 'PH_EMAIL' | translate }}</p>
                    <p class="edit-profile-account-items-area__item-info">{{ (profile$ | async)?.email }}</p>
                </ng-container>

                <ng-container
                    *ngIf="
                        (customerFields$ | async).indexOf('contact_person') >= 0 && getContactPerson(profile$ | async)
                    ">
                    <p class="edit-profile-account-items-area__item-title">{{ 'PH_CONTACT_PERSON' | translate }}</p>
                    <p class="edit-profile-account-items-area__item-info">{{ contactPerson }}</p>
                </ng-container>

                <ng-container *ngIf="(customerFields$ | async).indexOf('phone') >= 0">
                    <p class="edit-profile-account-items-area__item-title">{{ 'PH_PHONE' | translate }}</p>
                    <p>{{ getPhoneNumber(profile$ | async) ? contactPhone : (profile$ | async)?.phone }}</p>
                </ng-container>

                <ng-container *ngIf="(customerFields$ | async).indexOf('city') >= 0">
                    <p class="edit-profile-account-items-area__item-title">{{ 'PH_CITY' | translate }}</p>
                    <p class="edit-profile-account-items-area__item-info">{{ (profile$ | async)?.adr_city }}</p>
                </ng-container>

                <ng-container *ngIf="(customerFields$ | async).indexOf('street') >= 0">
                    <p class="edit-profile-account-items-area__item-title">{{ 'PH_STREET_1' | translate }}</p>
                    <p class="edit-profile-account-items-area__item-info">{{ (profile$ | async)?.adr_street_1 }}</p>
                </ng-container>

                <ng-container *ngIf="(customerFields$ | async).indexOf('postal_code') >= 0">
                    <p class="edit-profile-account-items-area__item-title">{{ 'PH_POSTAL_CODE' | translate }}</p>
                    <p class="edit-profile-account-items-area__item-info">{{ (profile$ | async)?.adr_zip }}</p>
                </ng-container>

                <ng-container *ngIf="(customerFields$ | async).indexOf('entitlements') >= 0">
                    <p class="edit-profile-account-items-area__item-title">{{ 'PH_ENTITLEMENTS' | translate }}</p>

                    <ul class="remove-bullets">
                        <li *ngFor="let entitlement of (profile$ | async).customer_discount_issued_detail">
                            <p class="edit-profile-account-items-area__item-info bold remove-margin-bottom">
                                {{ entitlement.category_name }}
                            </p>

                            <p
                                class="edit-profile-account-items-area__item-info remove-margin-bottom"
                                *ngIf="entitlement.reset_period === 'N'">
                                {{ resetPeriod(entitlement.reset_period) | translate }}
                            </p>

                            <p
                                class="edit-profile-account-items-area__item-info remove-margin-bottom"
                                *ngIf="entitlement.reset_period !== 'N'">
                                {{ resetPeriod(entitlement.reset_period) | translate }}
                                {{ entitlement.discount_used_amount }} {{ 'ENTITLEMENTS_USED_RIDES' | translate }}
                                {{ entitlement.sales_units }}
                            </p>

                            <p class="edit-profile-account-items-area__item-info margin-bottom-10">
                                <span class="margin-right-10">{{ 'ENTITLEMENTS_VALID_UNTIL' | translate }}</span
                                >{{ entitlement.starting | date: env.PRIMARY_DATE_FORMAT }} -
                                {{ entitlement.ending | date: env.PRIMARY_DATE_FORMAT }}
                            </p>
                        </li>
                    </ul>
                </ng-container>

                <ng-container *ngIf="(customerFields$ | async).indexOf('balance') >= 0">
                    <p class="edit-profile-account-items-area__item-title">{{ 'PH_BALANCE' | translate }}</p>
                    <p class="edit-profile-account-items-area__item-info bold">
                        {{ (profile$ | async)?.balance | centsToMajorUnit | moneyFormat }}
                        <span>{{ appStartupService.getCurrency() | translate }}</span>
                    </p>
                </ng-container>

                <!--I need to have a second component here for mobile-->
                <div class="show-mobile hide-desktop action-selector" *ngIf="(actions$ | async)?.length">
                    <ridango-account-actions-selector
                        [isOpened]="actionsDropdownOpened"
                        [actions]="actions$ | async"
                        [locale]="locale"
                        (onDropdownStatusChange)="dropdownStateChange($event)"
                        (onActionClicked)="actionClicked($event)">
                    </ridango-account-actions-selector>
                </div>
            </div>
        </div>
    </div>
</div>

<!-- TODO: is it the best place? -->
<ng-template #deleteConfirmation>
    <ridango-modal
        #modal
        [size]="'460'"
        [isItSmall]="true"
        [visible]="true"
        (onCloseModal)="!isLoading && cancelDelete()">
        <div class="modal-dialog-460__wrapper">
            <h1 class="modal-dialog-460__title" id="modal-aria-label">
                {{ 'ACCOUNT_DELETION_MODAL_TITLE' | translate }}
            </h1>

            <div class="margin-bottom-30">
                <p>{{ 'ACCOUNT_DELETION_MODAL_DESCRIPTION_1' | translate }}</p>
                <p>{{ 'ACCOUNT_DELETION_MODAL_DESCRIPTION_2' | translate }}</p>
                <p>{{ 'ACCOUNT_DELETION_MODAL_LIST_TITLE' | translate }}</p>

                <div class="block--bg-bullets margin-bottom-20 block">
                    <ul class="diferent-bullets" innerHtml="{{ 'ACCOUNT_DELETION_MODAL_LIST' | translate }}"></ul>
                </div>

                <p *ngIf="env.ACCOUNT_DELETE_CONFIRM_TYPE === accountDeleteConfirmationType.CONFIRM_WITH_EMAIL">
                    {{ 'ACCOUNT_DELETION_MODAL_CONFIRMATION_TEXT' | translate }}
                </p>

                <div *ngIf="env.ACCOUNT_DELETE_CONFIRM_TYPE === accountDeleteConfirmationType.CONFIRM_WITH_TICKBOX">
                    <span class="checkbox-wcag">
                        <input
                            class="checkbox-wcag__checkbox"
                            [checked]="accountDeletionConfirmed"
                            type="checkbox"
                            attr.aria-hidden="true"
                            tabindex="-1"
                            attr.aria-label="{{ 'READ_TERMS_CHECKBOX_ARIA_LABEL' | translate }}" />
                        <span
                            class="checkbox-wcag__checkmark"
                            (click)="toggleDeleteConfirmCheckbox()"
                            (keydown.space)="toggleTerms()"
                            tabindex="0"
                            attr.aria-checked="{{ accountDeletionConfirmed }}"
                            role="checkbox"
                            attr.aria-label="{{
                                'ACCOUNT_DELETION_MODAL_CONFIRMATION_CHECKBOX_ARIA_LABEL' | translate
                            }}">
                        </span>
                        <label class="checkbox-wcag__label checkbox-wcag__label--large-offset">
                            <span
                                class="link-label"
                                (click)="toggleDeleteConfirmCheckbox()"
                                (keydown.enter)="toggleDeleteConfirmCheckbox()"
                                (keydown.space)="toggleDeleteConfirmCheckbox()">
                                {{ 'ACCOUNT_DELETION_MODAL_CONFIRMATION_CHECKBOX' | translate }}
                            </span>
                        </label>
                    </span>
                </div>
            </div>

            <div class="align-center">
                <button
                    class="btn btn--big btn--primary btn--maximal margin-bottom-20"
                    *ngIf="
                        env.ACCOUNT_DELETE_CONFIRM_TYPE === accountDeleteConfirmationType.CONFIRM_WITH_EMAIL &&
                        !isLoading
                    "
                    (click)="confirmDelete()"
                    (keydown.enter)="confirmDelete()"
                    (keydown.space)="confirmDelete()"
                    tabindex="0">
                    <ridango-ui-basic-loading-spinner *ngIf="isLoading"></ridango-ui-basic-loading-spinner>
                    {{ 'ACCOUNT_DELETION_MODAL_BUTTON' | translate }}
                </button>

                <button
                    class="btn btn--big btn--primary btn--maximal margin-bottom-20"
                    *ngIf="
                        env.ACCOUNT_DELETE_CONFIRM_TYPE === accountDeleteConfirmationType.CONFIRM_WITH_TICKBOX &&
                        !isLoading
                    "
                    [disabled]="!accountDeletionConfirmed || isLoading"
                    (click)="confirmDeleteWithCheckbox()"
                    (keydown.enter)="confirmDeleteWithCheckbox()"
                    (keydown.space)="confirmDelete()"
                    tabindex="0">
                    {{ 'ACCOUNT_DELETION_MODAL_BUTTON' | translate }}
                </button>
                <div class="btn btn--big btn--primary btn--maximal margin-bottom-20" *ngIf="isLoading">
                    <ridango-ui-basic-loading-spinner></ridango-ui-basic-loading-spinner>
                </div>

                <a
                    class="link link--emphasized link--action modal-dialog__cancel-link"
                    (click)="!isLoading && cancelDelete()"
                    (keydown.enter)="cancelDelete()"
                    (keydown.space)="cancelDelete()"
                    tabindex="0"
                    >{{ 'ACCOUNT_DELETION_MODAL_CANCEL' | translate }}</a
                >
            </div>
        </div>
    </ridango-modal>
</ng-template>
